import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const createPassenger = createAsyncThunk(
  'passengers/createPassenger',
  catchAsync(async (data, thunkAPI) => {
    const res = await axios.post('/passengers', data);
    return res.data;
  })
);
